import { Injectable, computed, inject } from "@angular/core";
import { WkDataTableSortService } from ".";
import { WkDataTableContextService } from "@components/data-table/data-table-context.service";
import { WkDataTableSearchService } from "@app/shared/components/data-table/searchbar";

@Injectable()
export class WkDataTableItemsService<TItem> {
    private readonly dataTableContext = inject<WkDataTableContextService<TItem>>(WkDataTableContextService);
    private readonly dataTableSortService = inject<WkDataTableSortService<TItem>>(WkDataTableSortService);
    private readonly dataTableSearchService = inject<WkDataTableSearchService<TItem>>(WkDataTableSearchService);

    private readonly data = computed(() => this.dataTableContext.data?.() ?? []);
    private readonly appliedSearch = this.dataTableSearchService.applySearch(this.data);
    private readonly sorted = this.dataTableSortService.applySort(this.appliedSearch);
    public readonly items = computed(() => this.sorted());

    public getItem(index: number) {
        return this.items()?.[index];
    }
}
